// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import caseSoftware from './metaData/caseSoftware'
export default {
  state: caseSoftware,
  actions
}
